import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/index',
    component: () => import('@/views/Home.vue'),
    children: [
		 // 产品页
      {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index/index.vue'),
		  meta:{ title: 'TOZO智能'}
      },
		// 晒单提交
      {
        path: '/reward',
        name: 'reward',
        component: () => import('@/views/reward/reward.vue'),
		  meta:{ title: ''}
      },
		// 晒单详情
		{
		  path: '/rintingDetails',
		  name: 'rintingDetails',
		  component: () => import('@/views/reward/rintingDetails.vue'),
		  meta:{ title: ''}
		},
		
		// 售后服务
		{
		  path: '/after_saleService',
		  name: 'after_saleService',
		  component: () => import('@/views/AfterSales/after_saleService.vue'),
		  meta:{ title: '售后服务'}
		},
		
		// 保修卡列表
		{
		  path: '/myCardList',
		  name: 'myCardList',
		  component: () => import('@/views/warrantyCard/myCardList.vue'),
		  meta:{ title: '电子保修卡'}
		},
		// 失效的保修卡列表
		{
		  path: '/expireCardList',
		  name: 'expireCardList',
		  component: () => import('@/views/warrantyCard/expireCardList'),
		  meta:{ title: '失效保修卡'}
		},
		// 添加保修卡
		{
		  path: '/addCard',
		  name: 'addCard',
		  component: () => import('@/views/warrantyCard/addCard.vue'),
		  meta:{ title: '添加保修卡'}
		},
		// 编辑/查看保修卡
		{
		  path: '/editCard',
		  name: 'editCard',
		  component: () => import('@/views/warrantyCard/editCard.vue'),
		  meta:{ title: '查看保修卡'}
		},
    ]
  },
	{
		path: '*',
		name: 'NotFound',
		component: () => import("@/views/error-page/404"),
	}
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
/* 路由发生变化修改页面title */
	next()
	window.scrollTo(0,0); // 解决跳转后返回顶部
	if (to.meta.title) {
		document.title = to.meta.title //浏览器上的标题
	}
})


export default router
